import React from 'react';
import { AppButton, WarnModal } from '@common-fe/common-fe';

interface EnrollmentErrorModalProps {
  visible: boolean;
  onCancel: () => void;
  onTryAgain: () => void;
}

const EnrollmentErrorModal: React.FC<EnrollmentErrorModalProps> = ({ visible, onCancel, onTryAgain }) => (
  <WarnModal
    testId="enrollment-error-modal"
    visible={visible}
    onSetVisible={onCancel}
    header="Oops enrollment not updated"
    helptext={`There was an unexpected error and we couldn't save the data.
      Please check your enrollment details and try again. If the issue persists, please reach out to your administrator.`}
    buttonText="Cancel"
    submitButtonNode={
      <AppButton testId="enrollment-error_modal_submit" width="control" onClick={onTryAgain}>
        Try again
      </AppButton>
    }
    paddingless
  />
);

export default EnrollmentErrorModal;
